import React from "react";

const SplashScreen = () => {
  return (
    <div style={styles.container}>
      <div style={styles.iconCircle}>
        <img src={process.env.PUBLIC_URL + "/logo192.png"} alt="Karingana Logo" style={styles.logo} />
      </div>
      <div style={styles.spinner}></div>
      <div style={styles.textBlock}>
        <span style={styles.title}>Karingana</span>
        <span style={styles.slogan}>Aprende, diverte-te e desafia-te!</span>
        <span style={styles.subtitle}>O teu quiz moçambicano favorito</span>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    width: "100vw",
    background: "#fff",
    position: "fixed",
    top: 0,
    left: 0,
    zIndex: 2000,
    transition: "background 0.3s",
  },
  iconCircle: {
    width: 110,
    height: 110,
    borderRadius: "50%",
    background: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 4px 24px 0 rgba(0,0,0,0.08)",
    marginBottom: 32,
    border: "1.5px solid #e0e0e0",
    transition: "box-shadow 0.3s",
    overflow: "hidden",
  },
  logo: {
    width: 90,
    height: 90,
    objectFit: "cover",
    borderRadius: "50%",
    background: "#fff",
    boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
    border: "2px solid #fff",
    display: "block",
  },
  spinner: {
    width: 36,
    height: 36,
    border: "3.5px solid #e0e0e0",
    borderTop: "3.5px solid #d32f2f",
    borderRadius: "50%",
    animation: "splash-spin 1s linear infinite",
    marginBottom: 28,
  },
  textBlock: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 6,
  },
  title: {
    fontSize: 26,
    fontWeight: 700,
    color: "#222",
    letterSpacing: 1,
    marginBottom: 2,
    fontFamily: "'Montserrat', 'Segoe UI', Arial, sans-serif",
  },
  slogan: {
    fontSize: 15,
    color: "#d32f2f",
    fontWeight: 500,
    marginBottom: 2,
    fontFamily: "'Montserrat', 'Segoe UI', Arial, sans-serif",
  },
  subtitle: {
    fontSize: 13,
    color: "#888",
    fontWeight: 400,
    fontFamily: "'Montserrat', 'Segoe UI', Arial, sans-serif",
  },
};

// Animação global para o spinner
const styleSheet = document.createElement("style");
styleSheet.innerHTML = `
@keyframes splash-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}`;
document.head.appendChild(styleSheet);

export default SplashScreen; 